import React from 'react';
import { ChevronDown } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ContractClauseStatus } from '@/types/StatusType';

interface ClauseStatusProps {
  setClauseStatus: ContractClauseStatus;
  updateStatus: (status: ContractClauseStatus) => void;
}

export default function ContractClauseSelectStatus({
  setClauseStatus,
  updateStatus,
}: ClauseStatusProps) {
  const getButtonStyle = () => {
    switch (setClauseStatus) {
      case 'draft':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      case 'under_review':
        return 'bg-gray-100 text-gray-400 border-gray-500';
      case 'agreeable':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'suggested':
        return 'bg-indigo-100 text-indigo-800 border-indigo-300';
      case 'counter_proposed':
        return 'bg-orange-100 text-orange-400 border-orange-500';
      case 'contingent':
        return 'bg-purple-100 text-purple-400 border-purple-500';
      case 'rejected':
        return 'bg-rose-100 text-rose-400 border-rose-500';
      case 'take_it_or_leave_it':
        return 'bg-black text-white border-black-500';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  return (
    <>
      <Select
        onValueChange={(value) => updateStatus(value as ContractClauseStatus)}
      >
        <SelectTrigger>
          <SelectValue
            placeholder="Select a Clause Status"
            className={`text-sm text-gray-600 w-full`}
          >
            <Badge
              variant="outline"
              className={`capitalize ${getButtonStyle()} w-full text-sm`}
            >
              {setClauseStatus}
            </Badge>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="draft">Draft</SelectItem>
          <SelectItem value="under_review">Under Review</SelectItem>
          <SelectItem value="agreeable">Agreeable</SelectItem>
          <SelectItem value="suggested">Suggested</SelectItem>
          <SelectItem value="counter_proposed">Counter Proposed</SelectItem>
          <SelectItem value="contingent">Contingent</SelectItem>
          <SelectItem value="rejected">Rejected</SelectItem>
          <SelectItem value="take_it_or_leave_it">
            Take it Or Leave it
          </SelectItem>
        </SelectContent>
      </Select>
    </>
  );
}
